<template>
    <div class="text-center align-center justify-center overlay-section">
      <v-overlay v-model="overlay" class="align-center justify-center" absolute>
        <v-progress-circular
          color="primary"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>
    </div>
  </template>
  <style>
  /* .overlay-section {
    height: 1200px;
  } */
  </style>
  <script>
  // @ is an alias to /src
  export default {
    name: "AppLoading",
    data: () => ({
      overlay: true,
    }),
  };
  </script>
  